// removed by extract-text-webpack-plugin
module.exports = {"BlueprintEdit":"BlueprintEdit--Vh_YK","ShortDescription":"ShortDescription--2K70K","Actions":"Actions--3nYJl","button":"button--24tcq"};